export default __webpack_public_path__ + "static/media/gold about final b.80fadc61.png";